import { SearchScenarioId } from 'owa-search-next-common';
import { action } from 'satcheljs';

export const startSearchSession = action(
    'START_SEARCH_SESSION_NEXT',
    (actionSource: string, shouldStartSearch: boolean, scenarioId: SearchScenarioId) => ({
        actionSource,
        shouldStartSearch,
        scenarioId,
    })
);

export default startSearchSession;
